/** Czas na zestaw testów w Pythonie - wolniejszy niż JS, więc hojniejszy limit. */
export const PYTHON_RUN_TIMEOUT_MS = 6000;
